const MEDICAL_REQUEST_TYPES = [
  { value: null, displayName: "Todos" },
  { value: "exam", displayName: "Exame" },
  { value: "treatment", displayName: "Tratamento" },
  { value: "surgery", displayName: "Cirurgia" },
];

const findMedicalRequestItemTypeDisplayName = (medicalRequestType) => {
  const typeData = MEDICAL_REQUEST_TYPES.find(
    (type) => type.value == medicalRequestType
  );

  return typeData.displayName;
};

export { MEDICAL_REQUEST_TYPES, findMedicalRequestItemTypeDisplayName };
